import { render } from "./FormCheckboxes.vue?vue&type=template&id=cd7d5fa6"
import script from "./FormCheckboxes.vue?vue&type=script&lang=js"
export * from "./FormCheckboxes.vue?vue&type=script&lang=js"
script.render = render

export default script